var map = {
	"./sampang/Header.js": [
		6978,
		[
			613,
			229,
			978
		]
	],
	"./sampanganimation/Header.js": [
		6677,
		[
			613,
			768,
			546,
			729
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4946;
module.exports = webpackAsyncContext;